module.exports = __webpack_public_path__ + "static/pattern-combination-of-templates-7c340ae7f0efb9ce265bb0162a0154ff.png";